import React, { useState } from 'react'

interface StepGuideProps {
  step: number | undefined
  text: string
  show: boolean
  arrowAlign?: 'left' | 'center' | 'right'
  floating?: boolean
}

const StepGuide: React.FC<StepGuideProps> = ({ step, text, show, arrowAlign = 'center', floating = false }) => {
  const [dismissed, setDismissed] = useState(false)

  if (!show || dismissed) return null

  const arrowLeft = arrowAlign === 'left' ? '20px' : arrowAlign === 'right' ? 'calc(100% - 36px)' : '50%'

  return (
    <div style={{
      position: floating ? 'absolute' : 'relative',
      bottom: floating ? 'calc(100% + 10px)' : undefined,
      left: floating ? 0 : undefined,
      right: floating ? 0 : undefined,
      zIndex: floating ? 10 : undefined,
      marginBottom: floating ? 0 : '16px',
    }}>
      <div style={{
        background: '#0d6efd',
        color: 'white',
        borderRadius: '10px',
        padding: '10px 14px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        boxShadow: '0 2px 8px rgba(13,110,253,0.25)',
        fontSize: '0.88rem',
        lineHeight: '1.4',
      }}>
        {step && <span style={{
          background: 'white',
          color: '#0d6efd',
          borderRadius: '50%',
          width: '26px',
          height: '26px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 700,
          fontSize: '0.85rem',
          flexShrink: 0,
        }}>
          {step}
        </span>}
        <span style={{ flex: 1 }}>{text}</span>
        <button
          onClick={() => setDismissed(true)}
          style={{
            background: 'none',
            border: 'none',
            color: 'rgba(255,255,255,0.75)',
            cursor: 'pointer',
            padding: '0 2px',
            fontSize: '1rem',
            lineHeight: 1,
            flexShrink: 0,
          }}
          aria-label="Schließen"
        >
          ×
        </button>
      </div>
      <div style={{
        position: 'absolute',
        bottom: '-8px',
        left: arrowLeft,
        transform: 'translateX(-50%)',
        width: 0,
        height: 0,
        borderLeft: '9px solid transparent',
        borderRight: '9px solid transparent',
        borderTop: '9px solid #0d6efd',
      }} />
    </div>
  )
}

export default StepGuide
